import FacadeGlobal from '@/plugins/store/facades/facade-global';

export const setUserIp = ({ userIp, store }) => {
  const facadeGlobal = new FacadeGlobal(store);

  facadeGlobal.setUserIp(userIp);
};
